/**
 * Local (per-device) settings for the password-checkup breach check.
 *
 * - `breachCheck` — the Settings off switch. Default ON (absent key = on); set to
 *   `'off'` to disable the exposed check (weak/reused are unaffected).
 * - `disclosureAckAt` — ISO timestamp of the one-time disclosure acknowledgment.
 *   The exposed check does not send anything until this is set, so the very first
 *   query is always consented.
 *
 * localStorage, mirroring `theme/useTheme.ts`; guarded so a private-mode / absent
 * store never throws. Per-device in v1 (not synced across devices).
 */

const BREACH_KEY = 'hbs:checkup:breachCheck';
const DISCLOSURE_KEY = 'hbs:checkup:disclosureAckAt';

export function isBreachCheckEnabled(): boolean {
  try {
    return localStorage.getItem(BREACH_KEY) !== 'off';
  } catch {
    return true;
  }
}

export function setBreachCheckEnabled(enabled: boolean): void {
  try {
    if (enabled) localStorage.removeItem(BREACH_KEY);
    else localStorage.setItem(BREACH_KEY, 'off');
  } catch {
    /* ignore — per-device convenience only */
  }
}

export function hasAckedDisclosure(): boolean {
  try {
    return !!localStorage.getItem(DISCLOSURE_KEY);
  } catch {
    return false;
  }
}

export function ackDisclosure(): void {
  try {
    localStorage.setItem(DISCLOSURE_KEY, new Date().toISOString());
  } catch {
    /* ignore */
  }
}
